import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function Benefits() {
  const [benefits, setBenefits] = useState([]);
  const [checked, setChecked] = useState({});
  useEffect(() => { api.get("/benefits").then((r) => setBenefits(r.data.benefits || [])); }, []);

  const toggle = (k) => setChecked({ ...checked, [k]: !checked[k] });
  const active = benefits.filter((b) => checked[b.key]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
      <div className="eyebrow mb-4">BENEFIT FINDER</div>
      <h1 className="font-display text-4xl md:text-6xl font-bold leading-[0.95] mb-3">WHAT DO YOU ALREADY HAVE ACCESS TO?</h1>
      <p className="text-stone-400 max-w-xl mb-10">Tick what applies. We'll surface what it may unlock. We never guarantee eligibility — always verify with the official provider.</p>

      <div className="grid md:grid-cols-3 gap-3 mb-12">
        {benefits.map((b) => (
          <button key={b.key} onClick={() => toggle(b.key)} data-testid={`benefit-check-${b.key}`}
            className={`text-left border p-5 transition-colors ${checked[b.key] ? "border-[#E63946] bg-[#141417]" : "hairline hover:bg-[#141417]"}`}>
            <div className="flex items-center gap-3">
              <span className={`w-4 h-4 border flex items-center justify-center ${checked[b.key] ? "bg-[#E63946] border-[#E63946]" : "hairline"}`}>
                {checked[b.key] && <span className="text-white text-[10px]">✓</span>}
              </span>
              <span className="font-label text-xs tracking-widest">{b.label}</span>
            </div>
          </button>
        ))}
      </div>

      {active.length > 0 && (
        <div>
          <h2 className="font-label text-sm tracking-widest text-[#E63946] mb-5">YOU MIGHT ALREADY HAVE ACCESS TO…</h2>
          <div className="grid md:grid-cols-2 gap-4">
            {active.map((b) => (
              <a key={b.key} href={b.url} target="_blank" rel="noopener noreferrer" data-testid={`benefit-result-${b.key}`}
                className="group border hairline bg-[#141417] p-6 hover:border-[#E63946] transition-colors">
                <div className="flex items-start justify-between">
                  <h3 className="font-display text-2xl font-semibold mb-2 group-hover:text-[#E63946] transition-colors">{b.title}</h3>
                  <ArrowUpRight className="w-4 h-4 text-stone-600 group-hover:text-[#E63946]" />
                </div>
                <p className="text-sm text-stone-400">{b.note}</p>
                <p className="font-label text-[10px] tracking-widest text-stone-600 mt-3">VERIFY ELIGIBILITY WITH THE OFFICIAL PROVIDER</p>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
